import { createSlice } from '@reduxjs/toolkit';
import { findSelectFlavorExport } from './api';
import { initialState } from './api/interface';

const selectFlavorExportSlice = createSlice({
  name: 'selectFlavorExport',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findSelectFlavorExport.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findSelectFlavorExport.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.totalRecords = action.payload.total;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(findSelectFlavorExport.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
  },
});

export const { reset } =
  selectFlavorExportSlice.actions;
export default selectFlavorExportSlice.reducer;
